import { CheckmarkCircleFill, CloseCircleFill } from '@lyearn/icons';
import QuizNavigationSidebarItem from '@/modules/corporate/modules/quiz/views/QuizPlayer/components/QuizNavigationSidebar/QuizNavigationSidebarItem';
import { QuizNavigationSidebarItemProps } from '@/modules/corporate/modules/quiz/views/QuizPlayer/components/QuizNavigationSidebar/QuizNavigationSidebarItem/types';
import { Maybe, PerformanceEvaluationStatusEnum } from '@/types/schema';

import PartialTickCircle from '../icons/PartialTickCircle';

type Props = Omit<QuizNavigationSidebarItemProps, 'endAdornment' | 'variant'> & {
  evaluationStatus: Maybe<PerformanceEvaluationStatusEnum> | undefined;
};

const renderEndAdornment = (evaluationStatus: Props['evaluationStatus']) => {
  switch (evaluationStatus) {
    case PerformanceEvaluationStatusEnum.Correct: {
      return (
        <CheckmarkCircleFill
          className="h-20 w-20"
          data-test-id="correct-answer"
          fillColorToken="icon-success"
        />
      );
    }
    case PerformanceEvaluationStatusEnum.PartiallyCorrect: {
      return <PartialTickCircle className="h-20 w-20" data-test-id="partially-correct-answer" />;
    }
    case PerformanceEvaluationStatusEnum.InCorrect: {
      return (
        <CloseCircleFill
          className="h-20 w-20"
          data-test-id="incorrect-answer"
          fillColorToken="icon-error"
        />
      );
    }
    default: {
      return null;
    }
  }
};

const QuizReviewQuestionListItem = (props: Props) => {
  const { evaluationStatus, isSelected, question, questionIndex, onClick } = props;

  return (
    <QuizNavigationSidebarItem
      endAdornment={renderEndAdornment(evaluationStatus)}
      isSelected={isSelected}
      question={question}
      questionIndex={questionIndex}
      variant="review"
      onClick={onClick}
    />
  );
};

export default QuizReviewQuestionListItem;
